import React, { useEffect, useState } from "react";
import axios from "axios";

const ShowRoomBaghdadArtEditor = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [data, setData] = useState(null);
  const [msg, setMsg] = useState("");

  const [form, setForm] = useState({
    card1En: "",
    card1Ar: "",
    card1Ku: "",
    card2En: "",
    card2Ar: "",
    card2Ku: "",
    titleEn: "",
    titleAr: "",
    titleKu: "",
    descriptionEn: "",
    descriptionAr: "",
    descriptionKu: "",
  });

  const [uploadFile, setUploadFile] = useState(null);
  const [currentSlot, setCurrentSlot] = useState("");

  // =============================================
  // LOAD DATA IN 3 LANGUAGES
  // =============================================
  useEffect(() => {
    const load = async () => {
      try {
        const en = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadArt?lang=en`
        );
        const ar = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadArt?lang=ar`
        );
        const ku = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadArt?lang=ku`
        );

        setData(en.data);

        setForm({
          card1En: en.data.card1 || "",
          card1Ar: ar.data.card1 || "",
          card1Ku: ku.data.card1 || "",

          card2En: en.data.card2 || "",
          card2Ar: ar.data.card2 || "",
          card2Ku: ku.data.card2 || "",

          titleEn: en.data.title || "",
          titleAr: ar.data.title || "",
          titleKu: ku.data.title || "",

          descriptionEn: en.data.description || "",
          descriptionAr: ar.data.description || "",
          descriptionKu: ku.data.description || "",
        });

      } catch (err) {
        console.error("Failed to load ShowRoomBaghdadArt:", err);
      }
    };

    load();
  }, [API_BASE]);

  if (!data) return <p className="p-4">Loading...</p>;

  // =============================================
  // SAVE TEXTS
  // =============================================
  const saveText = async () => {
    try {
      await axios.put(
        `${API_BASE}/api/ShowRoomBaghdadArt/25304`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMsg("Texts updated successfully!");
    } catch (err) {
      console.error(err);
      setMsg("Failed to update texts.");
    }
  };

  // =============================================
  // UPLOAD IMAGE
  // =============================================
  const uploadImage = async () => {
    if (!uploadFile || !currentSlot) {
      setMsg("Please choose file & slot.");
      return;
    }

    const fd = new FormData();
    fd.append("ImageFile", uploadFile);
    fd.append("Replace", true);

    try {
      await axios.post(
        `${API_BASE}/api/ShowRoomBaghdadArt/25304/media/${currentSlot}`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMsg("Image updated successfully.");
      window.location.reload();

    } catch (err) {
      console.error(err);
      setMsg("Failed to upload image.");
    }
  };

  return (
    <div className="p-4">
      <h2>ShowRoom Baghdad Art Editor</h2>

      {msg && <div className="alert alert-info mt-3">{msg}</div>}

      {/* ================================== */}
      {/* IMAGE TABLE */}
      {/* ================================== */}
      <table className="table table-bordered mt-4">
        <thead className="table-dark">
          <tr>
            <th>Slot</th>
            <th>Preview</th>
            <th>Upload</th>
          </tr>
        </thead>

        <tbody>
          {[
            { slot: "bigTop", label: "Big Image Top", url: data.bigImageTop },
            { slot: "img1", label: "Grid Image 1", url: data.image1 },
            { slot: "img2", label: "Grid Image 2", url: data.image2 },
            { slot: "bigBottom", label: "Big Image Bottom", url: data.bigImageBottom },
          ].map((item) => (
            <tr key={item.slot}>
              <td>{item.label}</td>

              <td>
                <img
                  src={API_BASE + item.url}
                  alt="preview"
                  style={{
                    width: "220px",
                    borderRadius: "6px",
                    objectFit: "cover",
                  }}
                />
              </td>

              <td style={{ width: "260px" }}>
                <input
                  type="file"
                  className="form-control mb-2"
                  onChange={(e) => {
                    setUploadFile(e.target.files[0]);
                    setCurrentSlot(item.slot);
                  }}
                />
                <button
                  className="btn btn-dark w-100"
                  onClick={uploadImage}
                >
                  Upload
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ================================== */}
      {/* TEXT FIELDS */}
      {/* ================================== */}
      <h4 className="mt-5">Card 1</h4>
      <label className="fw-bold">English</label>
      <textarea
        className="form-control mb-2"
        value={form.card1En}
        onChange={(e) => setForm({ ...form, card1En: e.target.value })}
      />

      <label className="fw-bold">Arabic</label>
      <textarea
        className="form-control mb-2"
        value={form.card1Ar}
        onChange={(e) => setForm({ ...form, card1Ar: e.target.value })}
      />

      <label className="fw-bold">Kurdish</label>
      <textarea
        className="form-control mb-4"
        value={form.card1Ku}
        onChange={(e) => setForm({ ...form, card1Ku: e.target.value })}
      />

      <h4>Card 2</h4>
      <label className="fw-bold">English</label>
      <textarea
        className="form-control mb-2"
        value={form.card2En}
        onChange={(e) => setForm({ ...form, card2En: e.target.value })}
      />

      <label className="fw-bold">Arabic</label>
      <textarea
        className="form-control mb-2"
        value={form.card2Ar}
        onChange={(e) => setForm({ ...form, card2Ar: e.target.value })}
      />

      <label className="fw-bold">Kurdish</label>
      <textarea
        className="form-control mb-4"
        value={form.card2Ku}
        onChange={(e) => setForm({ ...form, card2Ku: e.target.value })}
      />

      <h4>Section Title</h4>
      <label className="fw-bold">English</label>
      <input
        className="form-control mb-2"
        value={form.titleEn}
        onChange={(e) => setForm({ ...form, titleEn: e.target.value })}
      />

      <label className="fw-bold">Arabic</label>
      <input
        className="form-control mb-2"
        value={form.titleAr}
        onChange={(e) => setForm({ ...form, titleAr: e.target.value })}
      />

      <label className="fw-bold">Kurdish</label>
      <input
        className="form-control mb-4"
        value={form.titleKu}
        onChange={(e) => setForm({ ...form, titleKu: e.target.value })}
      />

      <h4>Description</h4>
      <label className="fw-bold">English</label>
      <textarea
        className="form-control mb-2"
        value={form.descriptionEn}
        onChange={(e) =>
          setForm({ ...form, descriptionEn: e.target.value })
        }
      />

      <label className="fw-bold">Arabic</label>
      <textarea
        className="form-control mb-2"
        value={form.descriptionAr}
        onChange={(e) =>
          setForm({ ...form, descriptionAr: e.target.value })
        }
      />

      <label className="fw-bold">Kurdish</label>
      <textarea
        className="form-control mb-3"
        value={form.descriptionKu}
        onChange={(e) =>
          setForm({ ...form, descriptionKu: e.target.value })
        }
      />

      <button className="btn btn-primary w-100" onClick={saveText}>
        Save Texts
      </button>
    </div>
  );
};

export default ShowRoomBaghdadArtEditor;
